<template>
  <div class="u-flex-full">
    <div class="c-nav-dropdown__half">
      <sc-placeholder name="jss-column-left" :rendering="rendering" />
    </div>
    <div class="c-nav-dropdown__half">
      <div class="nav-with-bg">
        <sc-placeholder name="jss-column-right" :rendering="rendering" />
      </div>
      <sc-link
        v-if="fields && fields.linkRightBottom"
        :field="fields.linkRightBottom"
        class="c-cta--secondary"
        :class="fields.linkRightBottom.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-TwoColumn',
  components: {
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.c-nav-dropdown__half {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  > div {
    flex: 0 0 100%;
  }
}
.c-cta--secondary {
  margin: 1rem auto auto 0;
  @include desktop-up {
    margin-left: auto;
    margin-right: 0;
  }
}
</style>
